import PerfectScrollbar from 'react-perfect-scrollbar';
import { useEffect, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

import styles from './deal-taxes-expanded.module.css';
import axios from '../../utils/axios';
import { DealTaxesExpandedTable } from '../DealTaxes/components/DealTaxesExpandedTable';
import LoaderComponent from '../../components/TransitionComponent/LoaderContent';
import { LinkedButton } from '../../components/Button';
import { DealTaxesExpandedTableItem } from '../../types/deal-taxes';
import { Icon } from '../../components';
import { Icons } from '../../components/Icon/Icon';
import { type DealTaxesLayoutContextType } from '../DealTaxes/DealTaxesLayout';
import { useMenuStore } from '../../store/useMenuStore';

const DealTaxesExpanded = () => {
    // Get context from DealTaxesLayout
    const context = useOutletContext<DealTaxesLayoutContextType>();

    // Use context values
    const { tableUrl, setOnEdit } = context;

    const [data, setData] = useState<undefined | DealTaxesExpandedTableItem>(undefined);
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            const { data } = await axios.get<DealTaxesExpandedTableItem>('/deal-taxes/table' + window.location.search);
            setData(data);
        })();
    }, [tableUrl]);

    useEffect(() => {
        const handleEdit = () => {
            navigate('/deal-taxes' + window.location.search);
        };
        setOnEdit(handleEdit);
    }, []);

    return (
        <>
            <div className={styles.container}>
                <div className={styles.pageHeader}>
                    <h1 className={'text-grey'}>
                        <span className={'highlight-secondary'}>Tax review</span>: expanded view
                    </h1>

                    <div className={styles.btnWrapper}>
                        <LinkedButton
                            to={'/deal-taxes' + (tableUrl || window.location.search)}
                            size={'sm'}
                            after={<Icon icon={Icons.return} />}
                        >
                            Back to short view
                        </LinkedButton>
                    </div>
                </div>
                <LoaderComponent inProp={!!data}>
                    {data && (
                        <PerfectScrollbar className={`${styles.sectionWrapper}`}>
                            <DealTaxesExpandedTable data={data} />
                        </PerfectScrollbar>
                    )}
                </LoaderComponent>
            </div>
        </>
    );
};

export { DealTaxesExpanded };
